import { useEffect, useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { connect } from "react-redux";
import { changeLayoutMode } from "../store/actions";
import { layoutModeTypes } from "../constants/layout";

const ThemeSwitch = ({ layoutMode, changeLayoutMode }) => {
  const [isDarkMode, setIsDarkMode] = useState(
    layoutMode === layoutModeTypes.DARKMODE
  );

  useEffect(() => {
    setIsDarkMode(layoutMode === layoutModeTypes.DARKMODE);
  }, [layoutMode]);

  const handleThemeToggle = () => {
    const newMode = isDarkMode
      ? layoutModeTypes.LIGHTMODE
      : layoutModeTypes.DARKMODE;
    setIsDarkMode(!isDarkMode);
    changeLayoutMode(newMode);
  };

  return (
    <div style={{ display: "inline-block" }}>
      <label
        style={{
          position: "relative",
          display: "inline-block",
          width: "50px",
          height: "24px",
        }}
      >
        <input
          type="checkbox"
          checked={isDarkMode}
          onChange={handleThemeToggle}
          style={{ display: "none" }}
        />
        <span
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: isDarkMode ? "#2196f3" : "#ccc",
            transition: "0.4s",
            borderRadius: "24px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: isDarkMode ? "flex-end" : "flex-start",
            padding: "3px",
          }}
        >
          {isDarkMode ? (
            <FaMoon style={{ color: "white", fontSize: "14px" }} />
          ) : (
            <FaSun style={{ color: "yellow", fontSize: "16px" }} />
          )}
          <span
            style={{
              position: "absolute",
              height: "18px",
              width: "18px",
              backgroundColor: "white",
              borderRadius: "50%",
              transition: "0.4s",
              transform: isDarkMode ? "translateX(26px)" : "translateX(0px)",
            }}
          />
        </span>
      </label>
    </div>
  );
};

const mapStateToProps = (state) => ({
  layoutMode: state.Layout.layoutMode,
});

const mapDispatchToProps = {
  changeLayoutMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeSwitch);
